module.exports = __webpack_public_path__ + "img/inco3Ac.63797e67.png";